<div id="conditionsJuncture" class="container">
  @if (!flagService.flagServiceObject[8]['captchaJunctureFlag']) {
    <div class="row">
      <div class="col-12 p-0">
        <div class="component-header __indicator">
          <h3 class="label m-0">{{ 'junctures.condition.header' | translate }}</h3>
        </div>
      </div>
      <div class="col-12 pt-4">
        <span class="info pb-5 iinfo">{{ 'junctures.condition.info' | translate }}</span>
        <div id="pdfContainer">
          <a id="1" class="mb-2" [ngClass]="{ 'check': documentIsOK }" (click)="getPdfDocument(1)"><fa-icon class="faFilePdf me-2" [icon]="faFilePdf"></fa-icon>{{ 'junctures.condition.docs' | translate }} <fa-icon class="faCheck ms-3" [icon]="faCheck"></fa-icon></a>
        </div>
      </div>
      <div class="col-12 px-0 pt-3">
        @if (dataService.isKompakt() && dataService.isPartneri()) {
          <div class="condition">
            <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
            <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-1' | translate: { contractorName: dataService.HIPInsuredPersonFromHIPDto.contractorName } }}
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-2' | translate }}</p>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-3' | translate }}</p>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-4' | translate }}</p>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-5' | translate }}</p>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-6' | translate }}</p>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <span class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-7.p-0' | translate }}</span>
              <ul class="info ms-2">
                <li class="pb-1" innerHTML="{{ 'junctures.condition.conditions.kompaktNew.partner.c-7.p-1' | translate: { link: adatvedelemLink } }}"></li>
                <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.partner.c-7.p-2' | translate }}</li>
                <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.partner.c-7.p-3' | translate }}</li>
                <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.partner.c-7.p-4' | translate }}</li>
                <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.partner.c-7.p-5' | translate }}</li>
                <li>{{ 'junctures.condition.conditions.kompaktNew.partner.c-7.p-6' | translate }}</li>
              </ul>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <span class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-8.p-0' | translate }}</span>
              <ul class="info ms-2">
                <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.partner.c-8.p-1' | translate }}</li>
                <li>{{ 'junctures.condition.conditions.kompaktNew.partner.c-8.p-2' | translate }}</li>
              </ul>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-9' | translate }}</p>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-10' | translate }}</p>
            </div>
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-11' | translate }}</p>
            </div>
            @if (ageGroupService.choosenAgeGroup[0].id === '02') {
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.partner.c-12' | translate }}</p>
              </div>
            }
          }
          @if (dataService.isKompakt() && !dataService.isPartneri()) {
            <div class="condition">
              <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
              <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-1' | translate: { contractorName: dataService.HIPInsuredPersonFromHIPDto.contractorName } }}
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-2' | translate: { customerType1, customerType2 } }}</p>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-3' | translate }}</p>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-4' | translate }}</p>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-5' | translate }}</p>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-6' | translate }}</p>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-7' | translate }}</p>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <span class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-8.p-0' | translate }}</span>
                <ul class="info ms-2">
                  <li class="pb-1" innerHTML="{{ 'junctures.condition.conditions.kompaktNew.relative.c-8.p-1' | translate: { link: adatvedelemLink } }}"></li>
                  <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.relative.c-8.p-2' | translate }}</li>
                  <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.relative.c-8.p-3' | translate }}</li>
                  <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.relative.c-8.p-4' | translate }}</li>
                  <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.relative.c-8.p-5' | translate }}</li>
                  <li>{{ 'junctures.condition.conditions.kompaktNew.relative.c-8.p-6' | translate }}</li>
                </ul>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <span class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-9.p-0' | translate }}</span>
                <ul class="info ms-2">
                  <li class="pb-1">{{ 'junctures.condition.conditions.kompaktNew.relative.c-9.p-1' | translate }}</li>
                  <li>{{ 'junctures.condition.conditions.kompaktNew.relative.c-9.p-2' | translate }}</li>
                </ul>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-10' | translate }}</p>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-11' | translate }}</p>
              </div>
              <div class="condition">
                <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-12' | translate }}</p>
              </div>
              @if (ageGroupService.choosenAgeGroup[0].id === '02') {
                <div class="condition">
                  <input class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                  <p class="info">{{ 'junctures.condition.conditions.kompaktNew.relative.c-13' | translate }}</p>
                </div>
              }
            }
            @if (!dataService.isKompakt()) {
              <div class="condition">
                <input id="conditionFirst" class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                <p class="info">{{ 'junctures.condition.conditions.c-14' | translate: { contractorName: dataService.HIPInsuredPersonFromHIPDto.contractorName } }}
                </div>
                <div class="condition">
                  <input id="conditionSecond" class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                  <p class="info">{{ 'junctures.condition.conditions.c-15' | translate }}</p>
                </div>
                <div class="condition">
                  <input id="conditionThird" class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                  <p class="info">{{ 'junctures.condition.conditions.c-16' | translate }}</p>
                </div>
                <div class="condition">
                  <input id="conditionFourth" class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                  <p class="info">{{ 'junctures.condition.conditions.c-17.p-0' | translate }}</p>
                  <ul class="info ms-2">
                    <li class="pb-1" innerHTML="{{ 'junctures.condition.conditions.c-17.p-1' | translate: { link: adatvedelemLink } }}"></li>
                    <li class="pb-1">{{ 'junctures.condition.conditions.c-17.p-2' | translate }}</li>
                    <li class="pb-1">{{ 'junctures.condition.conditions.c-17.p-3' | translate }}</li>
                    <li class="pb-1">{{ 'junctures.condition.conditions.c-17.p-4' | translate }}</li>
                    <li class="pb-1">{{ 'junctures.condition.conditions.c-17.p-5' | translate }}</li>
                  </ul>
                </div>
                <div class="condition">
                  <input id="conditionFifth" class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                  <span class="info" innerHTML="{{ 'junctures.condition.conditions.c-18.p-0' | translate }}"></span>
                  <ul class="info ms-2">
                    <li class="pb-1">{{ 'junctures.condition.conditions.c-18.p-1' | translate }}</li>
                    <li class="pb-1">{{ 'junctures.condition.conditions.c-18.p-2' | translate }}</li>
                    <li>{{ 'junctures.condition.conditions.c-18.p-3' | translate }}</li>
                  </ul>
                </div>
                @if (ageGroupService.choosenAgeGroup[0].id === '02') {
                  <div class="condition">
                    <input id="conditionSixth" class="form-check-input" type="checkbox" (change)="checkCondition($event)">
                    <p class="info">{{ 'junctures.condition.conditions.c-19' | translate }}</p>
                  </div>
                }
              }
              @if (contractStartDate) {
                <div class="pt-4 pb-4 tooltip-trigger" [ngClass]="{'pointer': !dataService.isKompakt()}">
                  <span>{{ 'junctures.condition.contractStartDate' | translate }} </span>
                  <span>{{ contractStartDate }}; </span>
                  @if (!dataService.isKompakt()) {
                    <span>{{ 'junctures.condition.timeToWait' | translate }} </span>
                  }
                  <span>{{ 'junctures.condition.details' | translate }}</span>
                  @if (!dataService.isKompakt()) {
                    <div class="tooltip-reveal">
                      <span>{{ 'junctures.condition.startTime' | translate }}</span>
                    </div>
                  }
                </div>
              }
            </div>
            @if (errorMessage) {
              <div class="feedback invalid-feedback">{{ errorMessage }}</div>
            }
            <div class="d-flex summary mt-4">
              <div class="w-100">
                @if (documentIsOK && conditionCounter === getAllConditionsNumber()) {
                  <fa-icon class="text-center me-2" [icon]="faClipboardCheck"></fa-icon>
                  <div class="text">
                    <span class="name">{{ 'junctures.condition.all' | translate }}</span><br>
                    <span>{{ 'junctures.condition.status' | translate }}</span>
                  </div>
                }
              </div>
              <div class="flex-shrink-1">
                <button (click)="conditionsJunctureClick()" type="button" class="btn btn-light float-end ok-button">{{ 'common.ok' | translate }}</button>
              </div>
            </div>
          </div>
        }

        @if (flagService.flagServiceObject[8]['captchaJunctureFlag']) {
          <div class="row feedback-module" (click)="conditionsJunctureClick()">
            <div class="d-flex p-0">
              <a class="w-100">
                <fa-icon class="text-center ms-3 me-3" [icon]="faClipboardCheck"></fa-icon>
                <div class="text">
                  <span class="top">{{ 'junctures.condition.all' | translate }}</span><br>
                  <span class="bottom">{{ 'junctures.condition.status' | translate }}</span>
                </div>
              </a>
              <div class="flex-shrink-1">
                <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
              </div>
            </div>
          </div>
        }
      </div>
